import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Segment } from 'semantic-ui-react'
import { Manager } from '~/api/services/manager'
import { StyledGridColumns, StyledGridRow } from '~/pages/Users/User/Show/style'
import { StyledGridHeader } from '~/pages/Farmer/FarmerProfile/style'
import styled from 'styled-components'

const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
border-radius: 1.3rem !important;
box-shadow: none !important;
padding: 15px;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  margin-top: -1em !important;
  padding: 2rem 0rem 0rem 1rem !important;
  font-size: 18px !important;
 }
 .ui.grid>.row {
  flex-wrap: no-wrap !important;
 }
`

interface ShowProps {
  showData: Manager
}

const Show: React.FC<ShowProps> = ({ showData }) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  function handleCopyId() {
    if (!showData?.id) return
    navigator.clipboard.writeText(showData.id)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return <StyledSegment placeholder>
    <StyledGridHeader>{t('Profile details')}</StyledGridHeader>
    <Grid style={{ padding: 20 }} columns={3} divided>
      <Grid.Row>
        <Grid.Column>
          <Grid columns={2} stackable>
            <StyledGridRow>
              <Grid.Column>{t('AGIS ID Person')}</Grid.Column>
              <StyledGridColumns>{showData?.agisId || '-'}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Street & house number')}</Grid.Column>
              <StyledGridColumns>{`${showData?.streetName || '-'} ${showData?.streetNumber || '-'}`}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Membership application date')}</Grid.Column>
              <StyledGridColumns>{showData?.membershipApplicationDate ? dayjs(showData.membershipApplicationDate).format('DD.MM.YYYY') : '-'}</StyledGridColumns>
            </StyledGridRow>
            {/*   <StyledGridRow>
              <Grid.Column>{t('Email address')}</Grid.Column>
              <StyledGridColumns>{showData?.email || '-'}</StyledGridColumns>
            </StyledGridRow> */}
          </Grid>
        </Grid.Column>
        <Grid.Column>
          <Grid columns={2} stackable>
            <StyledGridRow>
              <Grid.Column>{t('First name')}</Grid.Column>
              <StyledGridColumns>{showData?.firstName || '-'}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Postal code')}</Grid.Column>
              <StyledGridColumns>{showData?.zip || '-'}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Country')}</Grid.Column>
              <StyledGridColumns>{showData?.country?.label || '-'}</StyledGridColumns>
            </StyledGridRow>
            {/*  <StyledGridRow>
              <Grid.Column>{t('Mobile number')}</Grid.Column>
              <StyledGridColumns>{showData?.mobileNumber || '-'}</StyledGridColumns>
            </StyledGridRow> */}
          </Grid>
        </Grid.Column>
        <Grid.Column>
          <Grid columns={2} stackable>
            <StyledGridRow>
              <Grid.Column>{t('Last name')}</Grid.Column>
              <StyledGridColumns>{showData?.lastName || '-'}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('City')}</Grid.Column>
              <StyledGridColumns>{showData?.city || '-'}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('BUR Number')}</Grid.Column>
              <StyledGridColumns>{showData?.burNumber || '-'}</StyledGridColumns>
            </StyledGridRow>
            {/*   <StyledGridRow>
              <Grid.Column>{t('Farmer ID')}</Grid.Column>
              <StyledGridColumns>{showData?.id || '-'}</StyledGridColumns>
            </StyledGridRow> */}
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </StyledSegment>
}

export default Show
